import React from 'react';
import axios from './../../../constants/axios';

class ServiceHome extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         services: []
      };
   }

   componentDidMount() {
      axios.get('/items/getAllServices')
         .then((res) => {
            this.setState({
               services: res.data
            });
         });
   }

   render() {
      const { services } = this.state;
      return (
         <div>
            <h3>Services</h3>
            <div className="__items" >
               <div className="row" >
                  <h5 className="col-md-1" >Id</h5>
                  <h5 className="col-md-5" >Name</h5>
                  <h5 className="col-md-2" >Service Change</h5>
                  <h5 className="col-md-2" >Actions</h5>
               </div>
               {services.map((service) => (
                  <div className="row" key={service.id} >
                     <div className="col-md-1" >{service.id}</div>
                     <div className="col-md-5" >{service.name}</div>
                     <div className="col-md-2" >{service.price}</div>
                     <div className="col-md-2" >Actions</div>
                  </div>
               ))}
            </div>
         </div>
      );
   }
}

export default ServiceHome;



/** WEBPACK FOOTER **
 ** ./src/components/ItemManagement/Service/ServiceHome.js
 **/